import { useEffect, useRef } from 'react'

export const useNativeEvent = (value: any, touched: boolean) => {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    const element = inputRef.current

    if (element && touched) {
      var nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        'value'
      )?.set
      if (nativeInputValueSetter) {
        nativeInputValueSetter.call(element, value)
      }

      const blurEvent = new Event('focusout', { bubbles: true })
      element.dispatchEvent(blurEvent)
      const inputEvent = new Event('change', { bubbles: true })
      element.dispatchEvent(inputEvent)
    }
  }, [inputRef, value, touched])

  return inputRef
}
